import React from 'react';
import { useTheme } from '../../../../contexts/ThemeContext';
import { cn } from '../../../../lib/utils';
import { 
  Modal,
  ModalHeader,
  ModalTitle,
  ModalContent,
  ModalFooter,
  Button,
  Textarea,
  Label,
  Select,
  SelectItem
} from '../../../../components/ui';

const ApprovalActionModal = ({
  isOpen,
  onClose,
  selectedActionType,
  actionData,
  setActionData,
  actionLoading,
  users,
  usersLoading,
  usersError,
  onHandleAction
}) => {
  const { theme } = useTheme();

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalHeader>
        <ModalTitle>
          {selectedActionType === 'approve' && 'Approve Request'}
          {selectedActionType === 'reject' && 'Reject Request'}
          {selectedActionType === 'delegate' && 'Delegate Request'}
        </ModalTitle>
      </ModalHeader>
      <ModalContent>
        <div className="space-y-4">
          {/* Comments field */}
          <div>
            <Label htmlFor="comments">Comments</Label>
            <Textarea
              id="comments"
              value={actionData.comments}
              onChange={(e) => setActionData({ ...actionData, comments: e.target.value })}
              placeholder="Enter your comments..."
              rows={3}
            />
          </div>

          {/* Reject reason field (only for reject action) */}
          {selectedActionType === 'reject' && (
            <div>
              <Label htmlFor="rejectReason">
                Rejection Reason <span className="text-red-500">*</span>
              </Label>
              <Textarea
                id="rejectReason"
                value={actionData.rejectReason}
                onChange={(e) => setActionData({ ...actionData, rejectReason: e.target.value })}
                placeholder="Enter the reason for rejection..."
                rows={3}
                required
              />
            </div>
          )}

          {/* Delegate field (only for delegate action) */}
          {selectedActionType === 'delegate' && (
            <div>
              <Label htmlFor="delegateTo">
                Delegate To <span className="text-red-500">*</span>
              </Label>
              <Select
                value={actionData.delegateTo || ''}
                onChange={(e) => setActionData({ ...actionData, delegateTo: e.target.value })}
                required
              >
                <SelectItem value="">Select a user to delegate to</SelectItem>
                {users?.map((user) => (
                  <SelectItem key={user.id} value={user.id.toString()}>
                    {user.userDisplayName || `${user.userFirstName || ''} ${user.userLastName || ''}`.trim() || user.userEmail}
                  </SelectItem>
                ))}
              </Select>
              {usersLoading && (
                <p className={cn("text-xs mt-1", theme.text.muted)}>Loading users...</p>
              )}
              {usersError && (
                <p className={cn("text-xs mt-1", theme.text.danger)}>Error loading users</p>
              )}
            </div>
          )}
        </div>
      </ModalContent>
      <ModalFooter className="flex justify-end space-x-3">
        <Button variant="outline" onClick={onClose}>
          Cancel
        </Button>
        <Button
          onClick={() => onHandleAction(selectedActionType)}
          disabled={
            actionLoading || 
            (selectedActionType === 'reject' && !actionData.rejectReason.trim()) ||
            (selectedActionType === 'delegate' && !actionData.delegateTo)
          }
          variant={selectedActionType === 'approve' ? 'default' : 
                  selectedActionType === 'reject' ? 'destructive' : 'default'}
        >
          {actionLoading ? 'Processing...' : 
           selectedActionType === 'approve' ? 'Approve' :
           selectedActionType === 'reject' ? 'Reject' : 'Delegate'}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ApprovalActionModal;
